/** @jsxImportSource theme-ui */

import { Box, Button, Flex, Heading, Image, Link, Text } from "theme-ui";
import Spacer from "../common/Spacer";
import { Link as RRDLink } from "react-router-dom";
import { ReactComponent as Lock } from "../../assets/lock.svg";
import { useRef, useEffect } from "react";

export default function WorkTile({
  bg,
  image,
  heading,
  body,
  link,
  extraLink,
  video,
  index,
}) {
  const videoRef = useRef();
  const bgAsHex = bg.startsWith("#");
  const bgIsGradient = typeof bg === "string" && bg.startsWith("linear-gradient");
  
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch((e) => console.log(e));
    }
  }, []);

  return (
    <Flex
      className="fadein"
      data-delay={(index / 3).toFixed(2)}
      sx={{
        flexDirection: "column",
        flex: 1,
        ...(index === 0 && { minWidth: [null, "40%"] }),
        opacity: "1 !important",
        transform: "none !important",
      }}
    >
        <Flex
          sx={{
            flexDirection: [
              "column",
              index % 2 !== 0 ? "column" : "column-reverse",
            ],
          }}
        >
        <Box
          as={RRDLink}
          to={link}
          sx={{
            position: "relative",
            borderRadius: "20px",
            overflow: "hidden",
            width: "100%",
            maxWidth: "100%",
            display: "block",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "-2px",
              left: "-2px",
              right: "-2px",
              bottom: "-2px",
              background: bgAsHex || bgIsGradient ? bg : `url(${bg})`,
              ...(bgIsGradient ? {} : {
                backgroundSize: bgAsHex ? "auto" : "cover",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
              }),
              zIndex: 0,
            }}
          />
          <Image
            src={image}
            sx={{
              width: "100%",
              height: "auto",
              display: "block",
              opacity: 0,
              pointerEvents: "none",
            }}
          />
          <video
            ref={videoRef}
            src={video}
            autoPlay
            muted
            playsInline
            preload="auto"
            loop
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: index === 0 ? "contain" : "cover",
              objectPosition: "center",
              opacity: 1,
              zIndex: 1,
            }}
          ></video>
        </Box>
        <Spacer height={["35px", "40px", index % 2 === 0 ? "48px" : "69px"]} />
        <Flex 
          sx={{ 
            flexDirection: "column",
          }}
        >
          <Heading as="strong" variant="h2">
            {heading}
          </Heading>
          <Spacer height={["25px", "20px"]} />
          <Text
            as="p"
            variant="body"
            sx={{ 
              fontWeight: "bold" 
            }}
          >
            {body}
          </Text>
        </Flex>
      </Flex>
      <Spacer height={["35px", "40px", "48px"]} />
      <Flex
        sx={{
          gap: "20px 35px",
          alignItems: "center",
          mt: [null, "auto"],
          flexWrap: "wrap",
        }}
      >
        <Button as={RRDLink} to={link} sx={{ gap: "10px" }}>
          View project
        </Button>
        {extraLink && (
          <Link
            sx={{
              variant: "text.caption",
              border: "none",
              lineHeight: "normal",
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
            href={extraLink.link}
          >
            {extraLink.text} <Lock />
          </Link>
        )}
      </Flex>
    </Flex>
  );
}
